<section class="main-navbar" [ngClass]="{'menu-collapsed': isMenuOpen, 'mob-menu-active': isMobMenuActive}">
  <div class="navbar-top">
    <button class="navbar-toggler" mat-icon-button aria-label="Mobile menu opener" (click)="menuToggler()">
      <svg width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect y="6.6416" width="22" height="2.12842" fill="white" />
        <rect y="0.256836" width="18" height="2.12842" fill="white" />
        <rect y="13.0273" width="14" height="2.12842" fill="white" />
      </svg>
    </button>
    <a class="navbar-logo" (click)="navigateToHome()" >
      <img src="assets/images/O3_Sigma_White.png" style="width: 8rem;"  alt="O3 Smart Manufacturing">
    </a>
  </div>
  <nav class="menu-nav">
    <!-- <ul class="menu-list"> -->
      <!-- routerLinkActive="active" -->
      <!-- <li class="list-item">
        <a class="list-link" (click)="navigateToHome()">
      <div class="link-icon">
        <div pTooltip="Home" tooltipPosition="right">
          <mat-icon>home</mat-icon>
        </div>
      </div>
      <p class="link-text" style="margin-bottom: 0px; margin-left: 32px;">Home</p>
    </a>
    </li>
      <li class="list-item" *ngFor="let menuItem of menus">
        <a class="list-link" [ngClass]="{
          'menu-item-active': false,
          '': false
        }" (click)="onClickMenu(menuItem)">
          <div class="link-icon">
            <div [pTooltip]="menuItem?.label" tooltipPosition="right">
              <img [src]="'assets/Content/Icon/' + menuItem?.icon " [alt]="menuItem?.label" width="32">
            </div>
          </div>
          <p class="link-text" style="margin-bottom: 0px;">{{getTransalatedValue(menuItem?.label)}}</p>
        </a>
      </li>
    </ul>
  </nav> -->

  <ul class="menu-list">
    <!-- Dynamic Dashboard (only if it exists) -->
    <li class="list-item" *ngIf="dynamicDashboard">
      <a class="list-link" [ngClass]="{ 'menu-item-active': false, '': false }" (click)="onClickMenu(dynamicDashboard)">
        <div class="link-icon">
          <div [pTooltip]="dynamicDashboard?.label" tooltipPosition="right">
            <img [src]="'assets/Content/Icon/' + dynamicDashboard?.icon" [alt]="dynamicDashboard?.label" width="32">
          </div>
        </div>
        <p class="link-text" style="margin-bottom: 0px;">{{ getTransalatedValue(dynamicDashboard?.label) }}</p>
      </a>
    </li>
  
    <!-- Home item -->
    <li class="list-item">
      <a class="list-link" (click)="navigateToHome()">
        <div class="link-icon">
          <div pTooltip="Home" tooltipPosition="right">
            <mat-icon>home</mat-icon>
          </div>
        </div>
        <p class="link-text" style="margin-bottom: 0px; margin-left: 32px;">Home</p>
      </a>
    </li>
  
    <!-- Dynamic items -->
    <li class="list-item" *ngFor="let menuItem of menus">
      <a class="list-link" [ngClass]="{ 'menu-item-active': false, '': false }" (click)="onClickMenu(menuItem)">
        <div class="link-icon">
          <div [pTooltip]="menuItem?.label" tooltipPosition="right">
            <img [src]="'assets/Content/Icon/' + menuItem?.icon" [alt]="menuItem?.label" width="32">
          </div>
        </div>
        <p class="link-text" style="margin-bottom: 0px;">{{ getTransalatedValue(menuItem?.label) }}</p>
      </a>
    </li>
  </ul>
  </nav>  
</section>